import validationMethods from '../../libs/validation';
import { removeElementsBySelector } from '../../libs/util';

// validation messages in head because of translation (labels.validation)
// export const validationMessages = {
//     required: "Dit veld is verplicht",
//     email: "Vul je HU e-mailadres in",
//     humail: "Vul je HU e-mailadres in"
// };


const selectors = {
    message: '.js-validation-message',
    fieldToValidate: '.js-do-validate'
}


function validateForm(form)
{
    console.log('validateForm');
    removeElementsBySelector(selectors.message, form);

    const inputsToValidate = Array.from(form.querySelectorAll(selectors.fieldToValidate));

    const validationResults = inputsToValidate.map(field => validateField(field));
    console.log(validationResults);
    return validationResults.every(res => res);
}
export default validateForm;


function validateField(field)
{
    if (!field.dataset.validation) return true;

    for (let validationType of field.dataset.validation.split(','))
    {
        validationType = validationType.trim();
        if (validationMethods[validationType] && !validationMethods[validationType](field.value))
        {
            field.parentNode.insertAdjacentHTML('beforeend', `<p class="${selectors.message.substr(1)} validation-message">${window.labels.validation[validationType]}</p>`);
            return false;
        }
    }

    return true;
}
